 //<script src="{{ 'complementary-cart.js' | asset_url }}" defer="defer"></script>

document.addEventListener('DOMContentLoaded', function() {

    // --- 1. SETUP: Variabili Globali e Selettori ---
    let isPopupBeingOpenedByCart = false; 
    const mobileBreakpoint = 768;
    let cartItemsObserver;
    let cartUpdateTimeout;
  
    const popup = document.getElementById('custom-popup-g');
    const backdrop = document.getElementById('custom-popup-backdrop-g');
    const closeButton = document.getElementById('close-popup-g');
    const complementaryElement = document.getElementById('complementary-product-data-g');
    const cartSidebar = document.getElementById('halo-cart-sidebar');
    const body = document.body;
    const openButtonProductPage = document.getElementById('open-popup'); // Bottone sulla pagina prodotto
    //const newUrl = `/recommendations/products?section_id=template--22425354010973__main&product_id=${productId}&limit=10&intent=complementary`;
    //const newUrl = `/recommendations/products?section_id=template--25232390127965__main&product_id=${productId}&limit=10&intent=complementary`;
    
    //versione live
    const newRecommendationsUrl = `/recommendations/products?section_id=template--22425354010973__main&limit=10&intent=complementary`;
    //versione locale test
    //const newRecommendationsUrl = `/recommendations/products?section_id=template--25232390127965__main&limit=10&intent=complementary`;

    // Verifica preliminare elementi popup
    // if (!popup || !backdrop || !complementaryElement || !closeButton) {
    //     console.warn("Popup complementare: Elementi base del popup (popup, backdrop, data, close) non trovati. Funzionalità limitata.");
    //     // Non usciamo, il resto potrebbe servire
    // }
    if (!cartSidebar) {
        console.warn("Popup complementare: Elemento #halo-cart-sidebar non trovato. Impossibile triggerare da carrello.");
        // Potresti voler disabilitare l'observer se la sidebar non c'è
    }


    const slickOptions = {
        infinite: false,         // Hai detto che lo usi
        variableWidth: true,    // Probabilmente lo usi se imposti larghezza slide in CSS
        // slidesToShow: 3,     // USA QUESTO se NON usi variableWidth
        // slidesToScroll: 1,    // Di solito 1 con variableWidth o slidesToShow
        arrows: true,           // Mostra frecce?
        dots: false,            // Mostra dots?
        prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>', // Incolla qui l'SVG o tag icona per PREV
        nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d=" M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',  // Incolla qui l'SVG o tag icona per NEXT        
        // Aggiungi qui altre opzioni Slick che usi (es. responsive)
        responsive: [
            {
                breakpoint: 768, // Esempio mobile
                settings: {
                    variableWidth: true, // O slidesToShow: 1 o 2
                    arrows: false,       // Nascondi frecce su mobile?
                    dots: true           // Mostra dots su mobile?
                }
            }
        ]
    };

    function initializeOrRefreshSlickSlider(context = 'sconosciuto') {
        const carouselElement = popup ? popup.querySelector('.products-carousel') : null;
        if (!carouselElement || typeof $ === 'undefined' || !$.fn.slick) { return false; } // Ritorna false se non può inizializzare
        const $carousel = $(carouselElement);
        console.log(`[Slick Init - ${context}] Tentativo inizializzazione/refresh.`);
        let success = false;
        try {
            if ($carousel.hasClass('slick-initialized')) {
                console.log(`[Slick Init - ${context}] Distruzione istanza Slick precedente...`);
                $carousel.slick('unslick');
            }
            // Inizializza SUBITO (senza setTimeout interno qui)
            console.log(`[Slick Init - ${context}] Inizializzazione Slick con opzioni:`, slickOptions);
            $carousel.slick(slickOptions);
            console.log(`[Slick Init - ${context}] Inizializzazione Slick completata.`);
            success = true;
        } catch (e) {
            console.error(`[Slick Init - ${context}] Errore inizializzazione/unslick Slick:`, e);
            success = false;
        }
        return success; // Ritorna true se l'inizializzazione è andata a buon fine (o non ha dato errori)
    }
    // --- 2. FUNZIONI HELPER (Assicurati che siano definite) ---

    // Funzione per aggiornare lo slider (scegli il metodo più efficace per te)
    const refreshSlider = () => {
        const carouselElement = popup ? popup.querySelector('.products-carousel') : null;
        if (!carouselElement) return;
        console.log('[Popup Complementare] Dispatching window resize event for slider refresh...');
        // Potresti aver bisogno di logica più specifica qui (es. unslick/reinit)
        // if (typeof $ !== 'undefined' && $.fn.slick && $(carouselElement).hasClass('slick-initialized')) {
        //    $(carouselElement).slick('setPosition'); // O altri comandi
        // }
    };

    // Funzione per aggiungere sottotitolo (se l'hai implementata)
    const addComplementarySubtitle = () => {
        const titleContainer = document.querySelector('#custom-popup-g .complementary-products-title');
        if (titleContainer && !titleContainer.querySelector('.complementary-products-subtitle')) {
            titleContainer.style.textAlign = 'center';
            const subtitleElement = document.createElement('p');
            subtitleElement.textContent = 'Ogni dettaglio conta: abbina questi prodotti per un outfit davvero completo.';
            subtitleElement.classList.add('complementary-products-subtitle');
            // Aggiungi stili se necessario
            subtitleElement.style.fontSize = '0.9em';
            subtitleElement.style.marginTop = '5px';
            subtitleElement.style.color = '#555';
            subtitleElement.style.textAlign = 'center';
            titleContainer.appendChild(subtitleElement);
            console.log('[Popup Complementare] Sottotitolo aggiunto.');
        }
    };

    // Funzione per calcolare max-width del carosello (se l'hai implementata)
    const updateCarouselMaxWidth = () => {
        const carouselElement = document.querySelector("#custom-popup-g .products-carousel");
        if (!carouselElement) return;
        const slides = carouselElement.querySelectorAll('.slick-slide:not(.slick-cloned)');
        const slideCount = slides.length;
        if (slideCount > 0) {
            const slideWidthTarget = 250; // O la tua larghezza target
            const calculatedMaxWidth = slideCount * slideWidthTarget; // Aggiusta se serve margine
            carouselElement.style.maxWidth = `${calculatedMaxWidth}px`;
            carouselElement.style.width = '100%';
            console.log(`[Popup Complementare] Max-width carosello aggiornata a ${calculatedMaxWidth}px per ${slideCount} slide.`);
        }
    };

    function adjustPopupToSidebar() {
        if (!popup || !backdrop || !cartSidebar || !body.classList.contains('cart-sidebar-show')) {
            return; // Non fare nulla se gli elementi non ci sono o la sidebar è chiusa
        }

        const sidebarWidth = cartSidebar.offsetWidth;
        const windowWidth = window.innerWidth;
        const availableWidth = windowWidth - sidebarWidth;

        console.log(`[Popup Complementare] Adattamento a sidebar. Sidebar Width: ${sidebarWidth}, Available Width: ${availableWidth}`);

        // Assumendo che la sidebar sia a DESTRA
        const styles = {
            top: '0px',
            bottom: '0px',
            left: '0px',
            right: sidebarWidth + 'px', // Allinea a sinistra della sidebar
            width: availableWidth + 'px' // Occupa lo spazio rimanente
            // Rimuovi justify/align se li avevi qui, usa il CSS di default
            // justifyContent: 'flex-start', // Allinea contenuto a sinistra
            // alignItems: 'flex-start' // Allinea contenuto in alto
        };

        // Applica stili a popup e backdrop
        Object.assign(popup.style, styles);
        Object.assign(backdrop.style, styles);

        // Aggiorna la max-width del contenuto se necessario (basato su slide)
        // Lo facciamo qui perché lo spazio disponibile è cambiato
        updateCarouselMaxWidth();
        // Triggera un refresh dello slider dopo un piccolo ritardo
        setTimeout(refreshSlider, 50);

    }

    // Rimuove gli stili inline per tornare al CSS di default (fullscreen/centered)
    function resetPopupToDefaultPosition() {
        if (!popup || !backdrop) return;
        console.log("[Popup Complementare] Reset posizione popup/backdrop a default.");
        // Lista degli stili da resettare
        const stylesToReset = ['top', 'bottom', 'left', 'right', 'width', 'justifyContent', 'alignItems'];
        stylesToReset.forEach(style => {
            popup.style[style] = '';
            backdrop.style[style] = '';
        });
    }

    // --- 3. FUNZIONE PRINCIPALE: Mostra e Aggiorna Popup ---
    function showComplementaryPopup(productId) {
        if (!complementaryElement || !popup || !backdrop) {
            console.error("[Popup Complementare] Impossibile mostrare popup: elementi mancanti.");
            return;
        }
        if (!productId){
            console.error("[Popup Complementare] ID Prodotto mancante per mostrare raccomandazioni.");
            return;
        }

        console.log(`[Popup Complementare] Preparazione per Product ID: ${productId}`);
        isPopupBeingOpenedByCart = true; // Imposta il flag

        const newUrl = newRecommendationsUrl + `&product_id=${productId}`;
        complementaryElement.dataset.url = newUrl; // Aggiorna l'URL per riferimento futuro

        // --- B. Carica Nuove Raccomandazioni (Metodo Fetch Raccomandato) ---
        console.log(`[Popup Complementare] Fetching raccomandazioni da: ${newUrl}`);
        complementaryElement.innerHTML = '<div class="loading-spinner"></div>'; // Mostra un loader (opzionale)

        fetch(newUrl)
            .then(response => {
                if (!response.ok) throw new Error(`Network response was not ok: ${response.statusText}`);
                return response.text();
            })
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                // Trova il *contenuto* specifico all'interno della risposta fetch
                const newContentWrapper = doc.querySelector('#complementary-product-data'); // Assumendo che l'endpoint ritorni la sezione stessa

                if (newContentWrapper && newContentWrapper.innerHTML.trim() !== '') {
                    complementaryElement.innerHTML = newContentWrapper.innerHTML; // Inietta il nuovo HTML
                    console.log("[Popup Complementare] Nuovo contenuto caricato.");

                    // --- C. Esegui azioni DOPO il caricamento ---
                    addComplementarySubtitle();
                    updateCarouselMaxWidth();
                    const slickInitialized = initializeOrRefreshSlickSlider('Fetch Desktop');

                    if (slickInitialized) {
                         console.log("[Popup Complementare] Slick inizializzato, ORA mostro popup desktop.");
                         // POSIZIONA E MOSTRA SOLO DOPO SUCCESSO INIT SLICK
                         resetPopupToDefaultPosition();
                         adjustPopupToSidebar(); // O reset a seconda del contesto
                         openPopupElements();
                    } else {
                         //  console.error("[Popup Complementare] Fallita inizializzazione Slick, popup non mostrato o mostro errore?");
                        //  complementaryElement.innerHTML = '<p>Errore visualizzazione prodotti.</p>';
                        //   // Decidi se mostrare popup con errore o lasciarlo nascosto
                        //  resetPopupToDefaultPosition();
                        //  adjustPopupToSidebar();
                        //  openPopupElements(); // Mostra popup con errore?
                    }

                } else {
                    // console.warn("[Popup Complementare] Nessun contenuto trovato.");
                    // complementaryElement.innerHTML = '<p>Nessun prodotto correlato trovato.</p>';
                    // resetPopupToDefaultPosition(); // Posiziona
                    // adjustPopupToSidebar();       // Posiziona
                    // openPopupElements();          // Mostra popup vuoto
                }
            })
            .catch(error => {
                // console.error("[Popup Complementare] Errore fetch raccomandazioni:", error);
                // complementaryElement.innerHTML = '<p style="text-align:center; padding: 20px;">Errore nel caricamento dei prodotti.</p>'; // Messaggio utente
                // openPopupElements();  
            });
    }

    // --- 4. LISTENER: Apertura Manuale (Pagina Prodotto) ---
    if (openButtonProductPage) {
        openButtonProductPage.addEventListener('click', (e) => {
            //e.preventDefault(); // Previene azioni default se è un link
             isPopupBeingOpenedByCart = false; // Non è aperto dal carrello
             let productId = complementaryElement ? complementaryElement.dataset.productId : null;
             if (!productId) {
                 // Prova a recuperare dal JSON della pagina prodotto
                 const productJsonElement = document.querySelector('script[type="application/json"][data-product-json]');
                 if (productJsonElement) {
                     try {
                         const productData = JSON.parse(productJsonElement.textContent);
                         if(productData && productData.id) productId = productData.id;
                     } catch (err) { console.error("Errore parsing JSON prodotto:", err); }
                 }
             }

             if (productId) {
                 // Per l'apertura da pagina prodotto, NON usiamo fetch, assumiamo
                 // che il contenuto sia già caricato o venga gestito dal componente.
                 // Svuotiamo l'eventuale contenuto caricato dal carrello? Forse sì.
                 // complementaryElement.innerHTML = ''; // OPZIONALE: resetta contenuto
                 // Ricarica il contenuto originale se necessario, oppure assumi sia già lì.

                 console.log(`[Popup Complementare] Apertura manuale per Product ID: ${productId}`);
                 // Assicurati che l'URL sia quello corretto per la pagina prodotto
                 // (potrebbe essere già impostato da Liquid)

                 // Aggiorna elementi grafici
                 addComplementarySubtitle();
                 updateCarouselMaxWidth();

                openPopupElements(); // Mostra popup e backdrop
                 // Aggiorna Slider
                 setTimeout(refreshSlider, 150);

             } else {
                  console.error("[Popup Complementare] Impossibile determinare ID prodotto per apertura manuale.");
             }
        });
    } else {
        console.log("[Popup Complementare] Bottone apertura manuale non trovato.");
    }


    function showMobileComplementary(productId, containerElement) { // Aggiunto containerElement
        // Trova il target DENTRO il container passato
        const targetElement = containerElement.querySelector('#mobile-complementary-target');
    
        if (!targetElement || !productId) {
            console.error("[Popup Mobile] Chiamata fallita: elemento target o ID Prodotto mancanti.");
            if(containerElement) containerElement.innerHTML = '<p>Errore interno.</p>'; // Aggiorna messaggio errore
            return;
        }

        // Recupera URL base dal dataset (uguale a desktop)
        const configElement = document.getElementById('complementary-product-data') || document.body;
        //const newUrl = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=4&intent=complementary`; // Limite minore per mobile?
        const newUrl = newRecommendationsUrl + `&product_id=${productId}`;

        console.log(`[Popup Mobile] Fetching raccomandazioni da: ${newUrl}`);
        targetElement.innerHTML = '<div style="text-align:center; padding: 10px;">Caricamento...</div>'; // Loader
        containerElement.style.display = 'block'; // Mostra contenitore

        fetch(newUrl)
            .then(response => response.ok ? response.text() : Promise.reject(`Errore fetch: ${response.statusText}`))
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                // ESTRAI SOLO LE CARD PRODOTTO, non tutta la struttura dello slider
                const productNodes = doc.querySelectorAll('#complementary-product-data .product'); // Selettore per le singole card prodotto

                if (productNodes && productNodes.length > 0) {
                    targetElement.innerHTML = ''; // Pulisci loader/vecchio contenuto
                    productNodes.forEach(node => {
                         // Clona il nodo per evitare problemi se viene rimosso dal 'doc'
                         targetElement.appendChild(node.cloneNode(true));
                    });
                    console.log(`[Popup Mobile] ${productNodes.length} prodotti caricati nella sidebar.`);
                     // NON serve inizializzare Slick Slider qui
                } else {
                     console.warn("[Popup Mobile] Nessun elemento '.product' trovato nella risposta fetch.");
                     targetElement.innerHTML = '<p style="text-align:center; padding: 10px; font-size: 0.9em;">Nessun suggerimento trovato.</p>';
                     // Lascia visibile il contenitore con il messaggio
                }
            })
            .catch(error => {
                console.error("[Popup Mobile] Errore fetch raccomandazioni:", error);
                targetElement.innerHTML = '<p style="text-align:center; padding: 10px; font-size: 0.9em;">Errore caricamento suggerimenti.</p>';
                 // Lascia visibile il contenitore con l'errore
            });
    }


    // --- Funzioni di Aggiornamento Carrello (Mobile e Desktop) ---
//     function handleMobileCartUpdate() {
//         console.log('[Popup Mobile] Eseguo handleMobileCartUpdate...');
//         const mobileContainer = document.getElementById('mobile-complementary-container');
//         if (!mobileContainer) { console.warn("handleMobileCartUpdate: Contenitore mobile non trovato."); return; }

//         fetch('/cart.js')
//             .then(r=>r.json())
//             .then(cartData => {
//                 let newLastProductId = cartData?.items?.[0]?.product_id;
//                 console.log("handleMobileCartUpdate: ID Prodotto da fetch:", newLastProductId);
//                 if (newLastProductId) {
//                     showMobileComplementary(newLastProductId, mobileContainer); // Chiama show specifico
//                 } else { // Carrello vuoto
//                     const mobileTarget = mobileContainer.querySelector('#mobile-complementary-target');
//                     if(mobileTarget) mobileTarget.innerHTML = '<p>Carrello vuoto.</p>';
//                     mobileContainer.style.display = 'block';
//                 }
//             })
//             .catch(e => console.error("Errore in handleMobileCartUpdate fetch:", e));
//    }

//    function handleDesktopCartUpdate() {
//         console.log('[Popup Desktop] Eseguo handleDesktopCartUpdate...');
//         // Verifica che il popup desktop esista e sia potenzialmente visibile
//         if (!popup || !complementaryElement) { console.warn("handleDesktopCartUpdate: Elementi popup desktop non trovati."); return; }

//         fetch('/cart.js')
//            .then(r=>r.json())
//            .then(cartData => {
//                 let newLastProductId = cartData?.items?.[0]?.product_id;
//                 console.log("handleDesktopCartUpdate: ID Prodotto da fetch:", newLastProductId);
//                 if (newLastProductId) {
//                     showComplementaryPopup(newLastProductId); // Chiama show specifico
//                 } else { // Carrello vuoto
//                     complementaryElement.innerHTML = '<p>Carrello vuoto.</p>';
//                     // Distruggi slick?
//                     const $carousel = $(popup.querySelector('.products-carousel'));
//                     if (typeof $ !== 'undefined' && $.fn.slick && $carousel.hasClass('slick-initialized')) { try { $carousel.slick('unslick'); } catch(e){} }
//                 }
//            })
//            .catch(e => console.error("Errore in handleDesktopCartUpdate fetch:", e));
//    }

    cartItemsObserver = new MutationObserver((mutationsList) => {
        const hasRelevantChanges = mutationsList.some(m => m.type === 'childList' || m.type === 'subtree');
        if (hasRelevantChanges) {
            console.log('[Popup Complementare] Rilevata modifica lista articoli...');
            clearTimeout(cartUpdateTimeout);
            cartUpdateTimeout = setTimeout(() => {
                // Controlla la larghezza QUI prima di decidere quale update chiamare
                if (window.innerWidth < mobileBreakpoint) {
                    handleMobileCartUpdate();
                } else {
                    handleDesktopCartUpdate();
                }
            }, 600);
        }
    });

    const startCartItemsObserver = () => {
        if (cartItemsObserver) { // Assicurati che l'observer sia stato creato
            const cartItemsList = cartSidebar?.querySelector('.previewCartList'); // Adatta selettore esatto per Halo
            if (cartItemsList) {
                // Disconnetti prima di ri-osservare per evitare duplicati
                cartItemsObserver.disconnect();
                const cartItemsConfig = { childList: true, subtree: true };
                console.log("[Popup Complementare] Avvio/Riattivazione observer su lista articoli carrello:", cartItemsList);
                try { cartItemsObserver.observe(cartItemsList, cartItemsConfig); }
                catch(e) { console.error("Errore avvio/riattivazione observe lista carrello:", e); }
            } else {
                console.warn("[Popup Complementare] Elemento lista articoli (.previewCartList) non trovato per l'osservazione.");
            }
        }
    };

    // --- 6. OBSERVER: Apertura Sidebar Carrello ---
        // --- OBSERVER PRINCIPALE: Apertura/Chiusura Sidebar ---
        const cartStateObserver = new MutationObserver((mutationsList) => {
            // Funzione interna per gestire l'avvio dell'observer degli item
            
    
            for (const mutation of mutationsList) {
                // Controlla solo le mutazioni rilevanti (classe sul body)
                if (mutation.type === 'attributes' && mutation.attributeName === 'class' && mutation.target === body) {
    
                    const cartOpenClassOnBody = 'cart-sidebar-show'; // Verifica questa classe per Halo!
                    const isCartOpenNow = body.classList.contains(cartOpenClassOnBody);
                    // Leggi il valore precedente memorizzato per un confronto affidabile
                    const wasCartOpenBefore = mutation.oldValue ? mutation.oldValue.includes(cartOpenClassOnBody) : false;
    
                    // Sidebar APPENA APERTA
                    if (isCartOpenNow && !wasCartOpenBefore) {
                        console.log('[Popup Complementare] Sidebar aperta rilevata.');
                        isPopupBeingOpenedByCart = true; // Imposta flag contesto
    
                        
                        // Determina modalità Mobile/Desktop
                        const isMobile = window.innerWidth < mobileBreakpoint;
                        body.dataset.viewMode = isMobile ? 'mobile' : 'desktop'; // Aggiorna stato attuale
                        
                        startSidebarContentLoadedObserver(); 
                        
                    } else if (!isCartOpenNow && wasCartOpenBefore) { // Sidebar APPENA CHIUSA
                        console.log('[Popup Complementare] Sidebar chiusa rilevata.');
                        // Disconnetti observer interno PRIMA di chiudere
                        if (sidebarContentLoadedObserver) sidebarContentLoadedObserver.disconnect();
                        if (cartItemsObserver) {
                            console.log("[Popup Complementare] Disconnessione observer lista articoli carrello.");
                            cartItemsObserver.disconnect();
                        }
                        closePopup(); // Chiama la funzione di chiusura completa (nasconde entrambi, resetta stili, ecc.)
                        delete body.dataset.viewMode; // Rimuovi stato
                    }
                    // Se la classe non è cambiata (isCartOpenNow === wasCartOpenBefore), non facciamo nulla qui
                }
            }
        });
    
         // --- ASSICURATI CHE QUESTE FUNZIONI ESISTANO E FACCIANO IL FETCH E L'AGGIORNAMENTO UI ---
         function handleMobileCartUpdate() {
             console.log('[Popup Mobile] Eseguo handleMobileCartUpdate...');
             const mobileContainer = document.getElementById('mobile-complementary-container');
             if (!mobileContainer) { console.warn("handleMobileCartUpdate: Contenitore mobile non trovato."); return; }
    
             fetch('/cart.js')
                 .then(r=>r.json())
                 .then(cartData => {
                     let newLastProductId = cartData?.items?.[0]?.product_id;
                     console.log("handleMobileCartUpdate: ID Prodotto da fetch:", newLastProductId);
                     // Mostra il contenitore anche se il carrello è vuoto per dare feedback
                     mobileContainer.style.display = 'block';
                     if (newLastProductId) {
                         showMobileComplementary(newLastProductId, mobileContainer); // Chiama show specifico
                     } else { // Carrello vuoto
                         const mobileTarget = mobileContainer.querySelector('#mobile-complementary-target');
                         if(mobileTarget) mobileTarget.innerHTML = '<p>Carrello vuoto.</p>';
                     }
                 })
                 .catch(e => {
                     console.error("Errore in handleMobileCartUpdate fetch:", e);
                     // Mostra errore nel contenitore mobile
                     if (mobileContainer) {
                          mobileContainer.style.display = 'block';
                          const mobileTarget = mobileContainer.querySelector('#mobile-complementary-target');
                          if (mobileTarget) mobileTarget.innerHTML = '<p>Errore caricamento carrello.</p>';
                     }
                });
        }
    
        function handleDesktopCartUpdate() {
             console.log('[Popup Desktop] Eseguo handleDesktopCartUpdate...');
             if (!popup || !complementaryElement) { console.warn("handleDesktopCartUpdate: Elementi popup desktop non trovati."); return; }
    
             fetch('/cart.js')
                .then(r=>r.json())
                .then(cartData => {
                     let newLastProductId = cartData?.items?.[0]?.product_id;
                     console.log("handleDesktopCartUpdate: ID Prodotto da fetch:", newLastProductId);
    
                     // Assicurati che il popup sia posizionato e visibile (potrebbe essere chiamato da observer interno)
                    //  if(popup.classList.contains('hidden')) {
                    //      resetPopupToDefaultPosition();
                    //      adjustPopupToSidebar();
                    //      openPopupElements();
                    //  }
    
    
                     if (newLastProductId) {
                         showComplementaryPopup(newLastProductId); // Chiama show specifico
                     } else { // Carrello vuoto
                         complementaryElement.innerHTML = '<p>Carrello vuoto.</p>';
                         // Distruggi slick
                         const $carousel = $(popup.querySelector('.products-carousel'));
                         if (typeof $ !== 'undefined' && $.fn.slick && $carousel.hasClass('slick-initialized')) { try { $carousel.slick('unslick'); } catch(e){} }
                     }
                })
                .catch(e => {
                    console.error("Errore in handleDesktopCartUpdate fetch:", e);
                     // Assicurati che il popup sia posizionato e visibile per mostrare errore
                     //if(popup.classList.contains('hidden')) {
                     //   resetPopupToDefaultPosition();
                     //   adjustPopupToSidebar();
                     //   openPopupElements();
                     //}
                     //if(complementaryElement) complementaryElement.innerHTML = '<p>Errore caricamento carrello.</p>';
                });
        }
    
        // --- Avvio Observer Principale sul BODY ---
        if (cartSidebar) {
            const bodyObserverConfig = { attributes: true, attributeOldValue: true };
            console.log("[Popup Complementare] Avvio observer per attributo 'class' su document.body...");
            try { cartStateObserver.observe(body, bodyObserverConfig); }
            catch (e) { console.error("Errore avvio observe sul body:", e); }
        }

    // Configurazione e avvio osservazione sul BODY
    const bodyObserverConfig = {
        attributes: true,
        attributeOldValue: true, // Fondamentale per rilevare l'aggiunta/rimozione
        subtree: false
    };
    console.log("[Popup Complementare] Avvio observer per attributo 'class' su document.body...");
    try {
        cartStateObserver.observe(body, bodyObserverConfig);
    } catch (e) {
        console.error("Errore durante l'observe sul body:", e);
    }

    const openPopupElements = () => {
        if (!popup || !backdrop) return;
        console.log("[Popup Complementare] Chiamata openPopupElements (rende visibile desktop).");
        if (backdrop) backdrop.classList.remove('hidden');
        popup.classList.remove('hidden'); // La classe hidden controlla opacity/visibility via CSS
        body.style.overflow = 'hidden';
    }
    // --- 7. GESTIONE CHIUSURA POPUP (Unificata) ---
    const closePopup = () => {
        if (!popup || !backdrop) return;
        if (popup.classList.contains('hidden')) return; // Già chiuso

        console.log("[Popup Complementare] Chiusura popup...");
        if (backdrop) backdrop.classList.add('hidden');
        popup.classList.add('hidden');
        document.body.style.overflow = ''; // Ripristina scroll principale

        // Reset specifico se è stato aperto dal carrello?
        if (isPopupBeingOpenedByCart) {
             console.log("[Popup Complementare] Popup chiuso (era stato aperto dal carrello).");
        }
        isPopupBeingOpenedByCart = false; // Resetta il flag
    };

    if (closeButton) closeButton.addEventListener('click', closePopup);
    if (backdrop) backdrop.addEventListener('click', closePopup);
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !popup.classList.contains('hidden')) {
            closePopup();
        }
    });

    let sidebarContentLoadedObserver;
    function startSidebarContentLoadedObserver() {
        if (!cartSidebar) return; // Sidebar non esiste

        // Seleziona l'elemento chiave da attendere (il tuo container o la lista)
        const targetElementSelector = '#mobile-complementary-container'; // O '.previewCartList'

        // Controlla se esiste già
        if (cartSidebar.querySelector(targetElementSelector)) {
             console.log("[Popup Complementare] Contenuto sidebar già presente, procedo subito.");
             handleSidebarReady(); // Contenuto già pronto
             return;
        }

        console.log(`[Popup Complementare] Contenuto sidebar (${targetElementSelector}) non ancora presente. Avvio observer su #halo-cart-sidebar...`);

        if (sidebarContentLoadedObserver) sidebarContentLoadedObserver.disconnect(); // Sicurezza

        sidebarContentLoadedObserver = new MutationObserver((mutationsList, observer) => {
            // Controlla se l'elemento target è stato aggiunto
            if (cartSidebar.querySelector(targetElementSelector)) {
                console.log(`[Popup Complementare] Contenuto sidebar (${targetElementSelector}) rilevato!`);
                observer.disconnect(); // Trovato, non serve più osservare per questo
                handleSidebarReady(); // Ora esegui la logica principale
            }
        });

        // Osserva la sidebar per aggiunte di figli/sottoalbero
        try {
             sidebarContentLoadedObserver.observe(cartSidebar, { childList: true, subtree: true });
        } catch (e) { console.error("Errore avvio observer contenuto sidebar:", e); }

         // Timeout di sicurezza: se dopo X secondi non trova nulla, rinuncia
         setTimeout(() => {
             if (sidebarContentLoadedObserver) { // Verifica se è ancora attivo (non ha trovato nulla)
                 console.warn("[Popup Complementare] Timeout attesa contenuto sidebar. Disconnetto observer.");
                 sidebarContentLoadedObserver.disconnect();
             }
         }, 3000); // Timeout di 3 secondi (esempio)
    }

    // --- NUOVA FUNZIONE: Esegue Logica Quando Sidebar è Pronta ---
    function handleSidebarReady() {
         console.log("[Popup Complementare] Eseguo handleSidebarReady...");
         const isMobile = body.dataset.viewMode === 'mobile'; // Leggi lo stato impostato prima

         if (isMobile) {
             handleMobileCartUpdate(); // Chiama handler mobile
         } else {
             // Desktop: posiziona, mostra guscio, chiama handler desktop
             resetPopupToDefaultPosition();
             adjustPopupToSidebar();
             //openPopupElements();
             handleDesktopCartUpdate();
         }
         // Avvia l'observer degli item ORA che la lista esiste sicuramente
         startCartItemsObserver();
    }
    
         // --- GESTIONE RESIZE FINESTRA ---
         let resizeTimeout;
     window.addEventListener('resize', () => {
        const isCurrentlyMobile = window.innerWidth < mobileBreakpoint;
        const currentMode = isCurrentlyMobile ? 'mobile' : 'desktop';
        const previousMode = body.dataset.viewMode;

        body.dataset.viewMode = currentMode; // Aggiorna stato subito

        // Gestisci resize solo se la sidebar è aperta
        if (body.classList.contains('cart-sidebar-show')) {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                console.log(`[Popup Complementare] Resize (debounce terminato). Modo Precedente: ${previousMode}, Modo Attuale: ${currentMode}`);

                if (cartStateObserver) { // Disconnetti observer body temporaneamente
                    console.log("[Popup Complementare] Disconnessione temporanea observer BODY");
                    cartStateObserver.disconnect();
                }

                const mobileContainer = document.getElementById('mobile-complementary-container');

                // --- Logica di Transizione e Adattamento ---

                if (currentMode === 'mobile') {
                    // --- Siamo o siamo passati a MOBILE ---
                    console.log("---> Vista MOBILE Attiva/Selezionata");
                    if (popup && !popup.classList.contains('hidden')) closePopup(); // Chiudi desktop

                    if (mobileContainer) {
                        mobileContainer.style.display = 'block'; // Assicura visibilità contenitore mobile
                        // Aggiorna/Popola Mobile SOLO se si proviene da desktop
                        if (previousMode === 'desktop') {
                            console.log("----> Transizione Desktop->Mobile: Chiamo handleMobileCartUpdate.");
                            handleMobileCartUpdate(); // Chiama la funzione dedicata
                        } else {
                           console.log("----> Rimasto su Mobile: Nessun aggiornamento contenuto da resize.");
                        }
                         // Riattiva observer interno (se necessario)
                         if (cartItemsObserver) { /* ... codice riattivazione ... */ }
                    } else { console.warn("----> Contenitore mobile non trovato!"); }

                } else {
                    // --- Siamo o siamo passati a DESKTOP ---
                    console.log("---> Vista DESKTOP Attiva/Selezionata");
                    if (mobileContainer) mobileContainer.style.display = 'none'; // Nascondi mobile

                    // Mostra/Posiziona guscio desktop
                    resetPopupToDefaultPosition();
                    adjustPopupToSidebar();
                    openPopupElements();

                    // Aggiorna/Popola Desktop SOLO se si proviene da mobile
                    if (previousMode === 'mobile') {
                         console.log("----> Transizione Mobile->Desktop: Chiamo handleDesktopCartUpdate.");
                         handleDesktopCartUpdate(); // Chiama la funzione dedicata
                    } else {
                         // Rimasto su desktop: Aggiorna solo lo slider esistente
                         console.log("----> Rimasto su Desktop: Aggiorno solo slider.");
                         if (popup && !popup.classList.contains('hidden')) {
                              initializeOrRefreshSlickSlider('Window Resize Desktop');
                         } else { console.log("-----> Popup desktop non visibile."); }
                    }
                     // Riattiva observer interno (se necessario)
                     if (cartItemsObserver) { /* ... codice riattivazione ... */ }
                }

                // --- RICONNETTI L'OBSERVER DEL BODY ---
                setTimeout(() => { /* ... codice riconnessione observer ... */ }, 100);

            }, 150); // Riduci il debounce del resize per più reattività? Prova 100ms
            } else {
                // Sidebar/Popup chiusi, resetta stato viewMode
                delete body.dataset.viewMode;
                // Assicurati che l'observer sia disconnesso se arriviamo qui
                // if (cartStateObserver) cartStateObserver.disconnect(); // Potrebbe essere già disconnesso dalla chiusura
            }
         });
     // Imposta stato iniziale al caricamento
     body.dataset.viewMode = window.innerWidth < mobileBreakpoint ? 'mobile' : 'desktop';

}); // Fine DOMContentLoaded